module.exports = {
    "Clear search": `Effacer la recherche`
};


//# sourceMappingURL=fr-FR.main.js.map
